import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Score from '@/components/comments/Score.vue';
import Drip from 'drip';
import KNB from '@dp/knb';
import CommentTips from './CommentTips.vue';
export default {
  name: 'DetailComment',
  components: {
    Score: Score,
    CommentTips: CommentTips
  },
  props: {
    scoreInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tabCounts: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    commentList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    projectId: {
      type: Number,
      default: null
    },
    commentInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isSeen: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      // 轮播评论定时器
      carousel: '',
      currentIndex: 0,
      // 轮播style
      style: {},
      // 末尾添加commentList首项的新数组
      afterPushFirstcommentList: [],
      // 是否展示头部评分说明
      isShowCommentTips: false
    };
  },
  computed: {
    scoreText: function scoreText() {
      if (!this.scoreInfo.score) return null;
      if (this.scoreInfo.score >= 9) {
        return '超棒';
      } else if (this.scoreInfo.score >= 7) {
        return '推荐';
      } else {
        return '';
      }
    }
  },
  mounted: function mounted() {
    window.seedAction({
      evt: 'view',
      bid: 'b_movie_ncwcx7b9_mv',
      cid: 'c_c21utqjf',
      abtest: 1,
      custom: {
        performance_id: this.projectId
      }
    });
    if (this.commentInfo.commentStatus && !this.commentList.length || this.commentList.length && this.commentInfo.commentStatus && !this.commentInfo.commented) {
      // 写评价按钮曝光
      window.seedAction({
        evt: 'view',
        bid: 'b_movie_pc9ixl7n_mv',
        cid: 'c_c21utqjf',
        abtest: 1,
        custom: {
          performance_id: this.projectId
        }
      });
    }
  },
  created: function created() {
    this.currentComment = this.commentList && this.commentList.length && this.commentList[0] || {};
    // 将第一项加载数组最后，解决最后一个轮播的问题
    this.afterPushFirstcommentList = this.commentList && this.commentList.length && [].concat(_toConsumableArray(this.commentList), [this.commentList[0]]) || [];
    this.setCarousel();
    this.dealHide();
  },
  destroyed: function destroyed() {
    document.removeEventListener('click', this.hideInfo);
    var isNative = Drip.UA.isNative;
    if (isNative) {
      ['appear', 'disappear', 'foreground', 'background'].forEach(function (action) {
        KNB.unsubscribe({
          action: action
        });
      });
    } else {
      window.removeEventListener('visibilitychange', this.visibleChange);
    }
    this.clearCarousel();
  },
  methods: {
    gotoWrite: function gotoWrite() {
      window.lxTagReport('c_c21utqjf', 'b_movie_pc9ixl7n_mc', {
        performance_id: this.projectId
      });
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_pc9ixl7n_mc',
        cid: 'c_c21utqjf',
        abtest: 1,
        custom: {
          performance_id: this.projectId
        }
      });
      this.$emit('postComment');
    },
    goTomyComment: function goTomyComment() {
      this.$emit('toCommentList', 1);
    },
    triggerCommentTip: function triggerCommentTip() {
      this.isShowCommentTips = !this.isShowCommentTips;
    },
    toCommentList: function toCommentList() {
      window.lxTagReport('c_c21utqjf', 'b_movie_ncwcx7b9_mc', {
        performance_id: this.projectId
      });
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_ncwcx7b9_mc',
        cid: 'c_c21utqjf',
        abtest: 1,
        custom: {
          performance_id: this.projectId
        }
      });
      this.$emit('toCommentList', 2);
    },
    // 设置评论轮播
    setCarousel: function setCarousel() {
      var _this = this;
      this.clearCarousel();
      // 解决最后一个轮播问题
      var commentList = this.afterPushFirstcommentList;
      var len = commentList.length;
      var style = {
        transform: 'translateY(0)',
        transition: 'transform 1200ms'
      };
      var emptyStyle = {};
      // 评论小于等于1，不轮播
      if (len <= 2) return;
      var timer = '';
      this.carousel = setInterval(function () {
        if (timer) {
          clearTimeout(timer);
          timer = '';
        }
        var currentIndex = _this.currentIndex;
        if (len && currentIndex < len - 1) {
          currentIndex++;
          var currenTranslateY = currentIndex;
          _this.currentIndex = currentIndex;
          style.transform = "translateY(".concat(-currenTranslateY * 5.1875, "rem)");
          _this.style = style;
          // 最后一个到第一个的变化
          if (currentIndex === len - 1) {
            timer = setTimeout(function () {
              _this.style = emptyStyle;
              _this.currentIndex = 0;
            }, 1200);
          }
        } else {
          _this.style = emptyStyle;
          _this.currentIndex = 0;
        }
      }, 5000);
    },
    // 清除定时器
    clearCarousel: function clearCarousel() {
      if (this.carousel) {
        clearInterval(this.carousel);
        this.carousel = '';
      }
    },
    visibleChange: function visibleChange() {
      if (document.visibilityState === 'hidden') {
        this.clearCarousel();
      } else {
        this.setCarousel();
      }
    },
    // 处理浏览器隐藏时，定时器被延缓
    dealHide: function dealHide() {
      var _this2 = this;
      var isNative = Drip.UA.isNative;
      // 容器内
      if (isNative) {
        var actionMapping = [{
          action: 'appear',
          handle: function handle() {
            return _this2.setCarousel();
          }
        }, {
          action: 'disappear',
          handle: function handle() {
            return _this2.clearCarousel();
          }
        }, {
          action: 'foreground',
          handle: function handle() {
            return _this2.setCarousel();
          }
        }, {
          action: 'background',
          handle: function handle() {
            return _this2.clearCarousel();
          }
        }];
        actionMapping.forEach(function (item) {
          KNB.subscribe({
            action: item.action,
            handle: item.handle
          });
        });
      } else {
        // 浏览器情况下
        window.addEventListener('visibilitychange', this.visibleChange);
      }
    },
    /**
     * @param {string} type
     */
    statsHandler: function statsHandler(type) {
      var option = {
        performance_id: this.projectId,
        city_id: Drip.constant.cityId
      };
      var self = this;
      var handle = {
        // 评论曝光
        commentView: function commentView() {
          window.seedAction({
            bid: 'b_movie_ys7qro2b_mv',
            evt: 'view',
            custom: Object.assign({}, option, {
              custom: Object.assign({}, option)
            })
          });
        },
        // 点击前往评论列表
        commentClick: function commentClick() {
          window.lxTagReport('c_c21utqjf', 'b_movie_ys7qro2b_mc', Object.assign({}, option));
          window.seedAction({
            bid: 'b_movie_ys7qro2b_mc',
            custom: Object.assign({}, option, {
              custom: Object.assign({}, option)
            })
          });
        }
      };
      return handle[type]();
    }
  }
};